export default __webpack_public_path__ + "static/media/price_tag.97d0b59a.svg";